<template>
  <div id="user">
    <Navbar :title="$t('成员')">
      <template #right>
        <div class="right_icon">
          <div @click.stop="settingClick">
            <van-icon name="setting-o" color="var(--light)" size="22" />
          </div>
          <div @click.stop="commentClick">
            <van-icon name="comment-o" color="var(--light)" size="22" />
          </div>
        </div>
      </template>
    </Navbar>
    <div class="userInfo_bar_wrap">
      <div class="user_titleContent">
        <div class="user_contentLeft">
          <div class="contentLeft_img">
            <Avatar :src="MemberInformation.userimg" :defaultSrc="require('@/assets/Img/myImg/head.png')" size="70" />
          </div>
          <div class="contentLeft_text">
            <div class="username">
              {{ MemberInformation.userphone
                ? MemberInformation.userphone
                : $t("newAdd.noLoginUserName")
              }}&nbsp;
              |&nbsp;<div class="rank">
                <img :src="MemberInformation.rank_picture" alt="">
                {{ MemberInformation.rank_title }}
              </div>
            </div>
            <div class="userInfo">
              <div class="userInfo_id">
                <span class="label">{{ "ID" }}:&nbsp;</span>
                <span class="value">{{ MemberInformation.id || "" }}</span>
              </div>
              <div class="userInfo_id">
                <span class="label">{{ $t("mine.credit") }}:&nbsp;</span>
                <span class="value">{{ MemberInformation.credit || "" }}</span>
              </div>
            </div>
            <div class="balance_bar">
              <div class="value">{{ $money(MemberInformation.money || 0) }}</div>
            </div>
            <!-- <div class="contentLeft_Vip" @click="showSign">
              <span class="label">{{ $t("member.title.level") }}:&nbsp;</span>
              <span class="value">
                {{ MemberInformation.rank_title || "" }}
              </span>
            </div> -->
            <!-- <div class="progress_">
              <div class="progress">
                <Progress :percentageStart="Number(MemberInformation.rank?.value || 0)"
                  :percentageEnd="Number(MemberInformation.rank?._next?.value || 0)" height="calc(8rem / 16)" isShow />
                {{ MemberInformation.rank?._next?.title }}
              </div>
            </div> -->
            <!-- <div class="contentLeft_Vip">
              <span class="label">{{ $t("mine.credit") }}:&nbsp;</span>
              <span class="value">
                {{ MemberInformation.credit || "" }}
              </span>
            </div> -->
          </div>
        </div>
        <!-- <ServiceBtn /> -->
      </div>
      <div class="top_nav_bg">
        <div class="top_nav_item" @click="itemClick('/vip')">
          <img src="../../assets/new/mine/vip.png" alt="">
          <span>{{ $t('VIP特权') }}</span>
        </div>
      </div>
      <div class="user_content">
        <div class="btns">
          <div class="btn_item" v-for="item, index in btn" :key="index" @click="itemClick(item.url)">
            <div class="item_icon">
              <img :src="item.icon" class="icon" alt="" />
            </div>
            <div class="text">{{ $t(item.label) }}</div>
          </div>
        </div>
      </div>
    </div>
    <CellGroup class="group" v-for="(g_item, g_index) in gridItemArr" :key="`group_${g_index}`">
      <Cell :to="item.page" is-link class="cell_item" v-for="(item, index) in g_item" @click="handleClick(item)"
        :key="index">
        <template #title>
          <div class="left_wrap">
            <!-- <i class="iconfont" :class="item.icon"></i> -->
            <img :src="item.icon" class="iconfonts">
            <span class="label">{{ $t(item.label) }}</span>
          </div>
        </template>
      </Cell>
    </CellGroup>
    <div class="logout">
      <Btn block color="var(--btn_bg)" @click="logoutEvent">
        {{ MemberInformation.token ? $t("My.logout") : $t("newAdd.Login") }}
      </Btn>
    </div>
    <van-action-sheet v-model="show" :actions="verConfig.lans || Lans" @close="onClose" @select="onSelect" />
    <!-- <Tabbar active="user" :language="language" /> -->
  </div>
</template>

<script>
import {
  Row,
  Col,
  Icon,
  Cell,
  GridItem,
  Grid,
  ActionSheet,
  Button,
  Image,
  Dialog,
  Toast,
  CellGroup,
  Button as Btn,
  // Progress
} from "vant";
import Navbar from "@/components/JNav";
import Progress from '@/components/progress'
import Tabbar from "@/components/Tabbar";
import { REQUEST_API } from "@/http/api"; // 引入封装的axios
import { GET_USER_INFP, editAvatar } from "@/api";
import { maskMiddle } from "@/utils/common"
// 设置vant的多语言
import Cookies from "js-cookie";
import { Locale } from "vant";
import enUS from "vant/lib/locale/lang/en-US";
// import zhCN from 'vant/lib/locale/lang/zh-CN'
import zhCN from "@/i18n/zh.js";
import thTH from "@/i18n/th.js";
import trTR from "@/i18n/tr.js";
import { countTime, getMyTime, deciTurnMoney } from "@/utils/tools";
import { Lans } from "@/i18n";
import ServiceBtn from "@/components/serviceBtn";
import { Avatar } from "@tt/components";
export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [GridItem.name]: GridItem,
    [Grid.name]: Grid,
    Navbar,
    [ActionSheet.name]: ActionSheet,
    [Button.name]: Button,
    [Image.name]: Image,
    [Dialog.name]: Dialog,
    CellGroup,
    Cell,
    Tabbar,
    ServiceBtn,
    Btn,
    Avatar,
    // [Progress.name]: Progress
    Progress,
  },
  data() {
    this.Lans = Lans;
    return {
      country: Cookies.get("language"),
      language: "",
      // MemberInformation: {},
      money: "",
      btn: [{
        label: '订金',
        icon: require('../../assets/new/mine/deposit.png'),
        url: '/new-recharge',
      }, {
        label: 'My.withdrawal',
        icon: require('../../assets/new/mine/withdraw.png'),
        url: '/new-withdraw'
      }, {
        label: 'My.invite',
        icon: require('../../assets/new/mine/invite.png'),
        url: '/inviteFriends'
      }, {
        label: '安全中心',
        icon: require('../../assets/new/mine/security.png'),
        url: '/securityCenter'
      }],
      gridItemArr: [
        [{
          label: "促销代码",
          icon: require('../../assets/new/mine/promo.png'),
          page: "/promoCode",
        }],
        [{
          label: "充值记录",
          icon: require('../../assets/new/mine/recharge_order.png'),
          page: "/recharge-list",
        }],
        [{
          label: "page.withdrawRecord",
          icon: require('../../assets/new/mine/withdraw_order.png'),
          page: "/withdraw-list",
        }],
        [{
          label: "账户记录",
          icon: require('../../assets/new/mine/account_order.png'),
          page: "/AccountData",
        }],
        [{
          label: `my.betRecord`,
          icon: require('../../assets/new/mine/bet_order.png'),
          page: "/cart",
        }],
        [{
          label: `my.wallet`,
          icon: require('../../assets/new/mine/wallet.png'),
          page: "/walletList",
        }],
        // [{
        //   label: `my.modifyPass`,
        //   icon: "icon-xiugaimima",
        //   page: "/Password",
        // }],
        // [{
        //   label: "My.personal",
        //   icon: "icon-gerenxinxi1",
        //   page: "/PersonalCenter",
        // }],
        // [{
        //   label: "mine.serviceTools.certify",
        //   icon: "icon-a-Frame2003",
        //   page: "/Certification",
        // }],
        // [{
        //   label: "agent.title.agent",
        //   icon: "icon-a-daili1",
        //   page: "/agent",
        // }],
        // [{
        //   label: "newAdd.inviteFriends",
        //   icon: "icon-yaoqinghaoyou",
        //   page: "/inviteFriends",
        // }],
        [{
          label: "My.language",
          icon: require('../../assets/new/mine/language.png'),
          callBack: () => {
            this.show = true;
          },
        }]
        // [
        //   {
        //     label: "My.language",
        //     icon: "icon-yuyanshezhi",
        //     callBack: () => {
        //       this.show = true;
        //     },
        //   },
        //   // {
        //   //   label: "My.download",
        //   //   icon: "icon-xiazai1",
        //   //   callBack: () => {
        //   //     if (this.$cookie.get("userInfo")) {
        //   //       if (localStorage.getItem("android")) {
        //   //         location.href = localStorage.getItem("android");
        //   //       } else {
        //   //         location.href = "http://www.baidu.com";
        //   //       }
        //   //     } else {
        //   //       this.$toast(
        //   //         "You are not logged in. Please log in and try again!"
        //   //       );
        //   //     }
        //   //   },
        //   // },
        // ],
        // vip推广页面
        // {
        //   id: 1,
        //   t: `my.vip`,
        //   flag: true,
        //   icon: "icon-VIP1",
        //   page: "/levelUpgrade",
        // },
        // 手机验证
        // {
        //   id: 2,
        //   t: `my.verifyPhone`,
        //   flag: true,
        //   icon: "icon-shoujihaoma",
        //   page: "/PhoneVerify",
        // },
        // 充值
        // {
        //   id: 2,
        //   url: require("@/assets/Img/myImg/Recharge.png"),
        //   t: `newTab.money`,
        //   flag: true,
        //   callBack: () => {
        //     this.$router.push("recharge-list");
        //   },
        // },
        // 提现
        // {
        //   id: 3,
        //   url: require("@/assets/Img/myImg/withdrawal.png"),
        //   t: `My.withdrawal`,
        //   flag: true,
        //   // t: this.$t("My.AccountRecord"),
        //   callBack: () => {
        //     if (this.$cookie.get("userInfo")) {
        //       this.$router.push("withdraw-list"); // 账户资料跳转-小饶
        //     } else {
        //       this.$toast(
        //         "You are not logged in. Please log in and try again!"
        //       );
        //     }
        //   },
        // },
        // 个人中心
        // {
        //   id: 4,
        //   url: require("@/assets/Img/myImg/personal-info.png"),
        //   t: `My.personal`,
        //   flag: true,
        //   callBack: () => {
        //     if (this.$cookie.get("userInfo")) {
        //       this.$router.push("PersonalCenter"); // 个人中心跳转-小饶
        //     } else {
        //       this.$toast(
        //         "You are not logged in. Please log in and try again!"
        //       );
        //     }
        //   },
        // },
        // 客服
        // {
        //   id: 5,
        //   url: require("@/assets/Img/myImg/kefu.png"),
        //   t: `mine.servier`,
        //   flag: true,
        //   callBack: () => {
        //     if (localStorage.getItem("service_url")) {
        //       location.href = localStorage.getItem("service_url");
        //     } else {
        //       this.$toast("The call center is not online yet");
        //     }
        //   },
        // },
        // 下载
        // {
        //   id: 7,
        //   url: require("@/assets/Img/myImg/downT.png"),
        //   t: `My.download`,
        //   flag: this.$isDownloadFn,
        //   icon: "icon-xiazai-wenjianxiazai-08",
        //   callBack: () => {
        //     console.log(1);
        //     if (this.$cookie.get("userInfo")) {
        //       if (localStorage.getItem("android")) {
        //         location.href = localStorage.getItem("android");
        //       } else {
        //         location.href = "http://www.baidu.com";
        //       }
        //     } else {
        //       this.$toast(
        //         "You are not logged in. Please log in and try again!"
        //       );
        //     }
        //   },
        // },
        // 邀请
        // {
        //   id: 8,
        //   url: require("@/assets/Img/myImg/sharePink.png"),
        //   t: `My.invite`,
        //   icon: "icon-fenxiang",
        //   flag: true,
        //   callBack: () => {
        //     // this.$router.push('InviteFriends') // 邀请好友跳转-小饶
        //     this.$router.push("/inviteFriends");
        //   },
        // },
        // 公司介绍
        // {
        //   id: 8,
        //   url: require("@/assets/Img/myImg/introduce.png"),
        //   t: `user.tools.introduce`,
        //   flag: true,
        //   callBack: () => {
        //     // this.$router.push('InviteFriends') // 邀请好友跳转-小饶
        //     this.$router.push("introduce");
        //   },
        // },
        // crypto
        // {
        //   id: 9,
        //   url: require("@/assets/Img/myImg/crypto.png"),
        //   t: `user.tools.crypto`,
        //   flag: true,
        //   callBack: () => {
        //     // this.$router.push('InviteFriends') // 邀请好友跳转-小饶
        //     this.$router.push("crypto");
        //   },
        // },
        // 币安
        // {
        //   id: 10,
        //   url: require("@/assets/Img/myImg/Binance.png"),
        //   t: `user.tools.ba`,
        //   flag: true,
        //   callBack: () => {
        //     // this.$router.push('InviteFriends') // 邀请好友跳转-小饶
        //     this.$router.push("ba");
        //   },
        // },
        // {
        //   id: 7,
        //   url: require('@/assets/icon/myself/service.png'),
        //   t: `My.service`,
        //   callBack: () => {
        // this.$router.push('Announcement') // 系统公告-小饶
        // this.$api.toService()
        // },
        // },
        // {
        //   id: 8,
        //   url: require('@/assets/Img/myImg/Teamreport.png'),
        //   t: `My.team`,
        //   callBack: () => {
        //     this.$router.push('TheTeamReport') // 系统公告-小饶
        //   },
        // },
        /**
         * 语言修改
         */
        // {
        //   id: 9,
        //   url: require("@/assets/Img/myImg/language.png"),
        //   t: `My.language`,
        //   icon: "icon-duoyuyan1",
        //   flag: true,
        //   callBack: () => {
        //     this.show = true;
        //   },
        // },
      ],
      show: false,
      levelText: "",
    };
  },
  computed: {
    MemberInformation() {
      const userinfo = this.$store.getters.userInfo;
      return { ...userinfo, username: maskMiddle(userinfo.username) }
    }
  },
  methods: {
    settingClick() {
      this.itemClick("/PersonalCenter")
    },
    commentClick() {
      this.itemClick('/Message')
    },
    itemClick(url) {
      if (!url) return;
      this.$router.push(url);
    },
    showSign() {
      // console.log(1, this.MemberInformation.sign);
      if (this.MemberInformation?.sign) {
        Dialog.alert({
          message: this.MemberInformation.sign,
          confirmButtonText: this.$t("My.Button.Two")
        })
      }
    },
    handleClick(row) {
      if (!!row.callBack) {
        row.callBack();
      }
    },
    //会员说明
    explain() {
      this.$router.push({ name: "levelUpgrade" });
    },
    handleLinkBill() {
      this.$router.push("bill-record"); // 个人中心跳转-小饶
    },
    onSelect(e) {
      this.$i18n.Locale = e.value;
      this.changeLanguage(e.value)
      Cookies.set('lang', e.value)
      Cookies.set('language', e.value)
      this.language = e.value;
      // this.$store.dispatch("getBanner");
      // this.$store.dispatch("getGameCategory");
      this.$store.dispatch("getCountry");
      this.show = false;
    },
    // 顶部导航栏的设置事件-小饶
    Personal() {
      if (this.$cookie.get("userInfo")) {
        this.$router.push("PersonalCenter");
      } else {
        this.$toast(this.$t("newAdd.NotLogin"));
      }
    },
    onClose() {
      this.show = false;
    },
    // 点击充值的按钮
    RechargeEvent() {
      Dialog.alert({
        title: this.$t('My.MemberInformation.Recharge'),
        message: this.$t('hint.lxkf'),
        showCancelButton: true,
        confirmButtonText: this.$t('Login.goLoginText'),
        cancelButtonText: this.$t('newAdd.Cancel')
      }).then(() => {
        this.$api.toService();
      }).catch(() => {
      });
      // this.$router.push("/new-recharge");
    },
    // 点击提现按钮
    WithdrawEvent() {
      this.$router.push({ name: "newWithdraw" });
    },
    // 注销的按钮
    logoutEvent() {
      let _this = this;
      if (_this.MemberInformation.token) {
        Dialog.confirm({
          // title: this.$t("My.quit"),
          message: this.$t("My.logoutEvent"),
          cancelButtonText: this.$t("My.Button.One"),
          confirmButtonText: this.$t("My.Button.Two"),
        })
          .then(() => {
            let pwdState = _this.$cookie.get("the-pwd-state");
            let pwdObj = _this.$cookie.get("the-pwd-obj");
            _this.$cookie.clear();
            _this.$cookie.set("the-pwd-state", pwdState);
            _this.$cookie.set("the-pwd-obj", pwdObj);
            _this.$router.push("/login");
            // window.location.reload()
          })
          .catch(() => {
            // on cancel
          });
      } else {
        this.$router.push("/login");
      }
    },
    // 获取账户余额
    BalanceEvent() {
      let form = {
        cmd: "202445",
        uid: this.module.UIDEvent(),
      };
      REQUEST_API(form).then((res) => {
        this.$store.commit("SET_MONEY_INFO", res.data.notifyList[0].data);
        // this.money = res.data.notifyList[0].data.diamond
        this.money = deciTurnMoney(this.$store.state.user.moneyObj.diamond);
      });
    },
    // 获取用户信息
    getUserInfo() {
      // if (this.$cookie.get('userInfo')) {
      //   this.MemberInformation = JSON.parse(this.$cookie.get('userInfo'))
      // }
      Toast.loading({
        forbidClick: true,
        duration: 0,
      });
      this.$api.getUserInfo(
        (res) => {
          Toast.clear();
          this.MemberInformation = { ...res, username: maskMiddle(res.username) };
        },
        (err) => {
          Toast.clear();
        }
      );
    },
    getUserInfo2() {
      GET_USER_INFP()
        .then((r) => {
          if (r.data.ret === 1) {
            this.$cookie.set("userInfo", JSON.stringify(r.data.data));
            this.$cookie.set("token", r.data.data.token);
            this.MemberInformation = r.data.data;
          }
        })
        .catch((e) => {
          console.error(e);
        });
    },
    getDownloadUrl() {
      let url = {};
      let down = {
        id: 5,
        url: require("@/assets/icon/myself/download.png"),
        t: `My.download`,
        callBack: () => {
          window.location.href = url.android;
        },
      };
      this.$api.getNotice((res) => {
        if (res.appurl_android) {
          url.android = res.appurl_android;
          // this.gridItemArr.push(down);
        }
      });
    },
  },
  created() {
    this.$store.dispatch('getuserInfo')
    // this.getUserInfo();
    // this.getDownloadUrl();
  },
};
</script>

<style lang="less" scoped>
// @Color: #e23d6d;
@Color: var(--theme);
@button-border-radius: 20px;
@wrapPadding: calc(12rem / 16);
@comRadius: 10px;
// @comBG: linear-gradient(#093958, #022c47);
@comBG: var(--bg1);

// 弹性布局
.flex(@JC: center; @FW: nowrap; @AI: center; @FD: row) {
  display: flex;
  flex-wrap: @FW;
  flex-direction: @FD;
  justify-content: @JC;
  align-items: @AI;
}

// 文字超出省略号
.text-overflow(@num: 1) {
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: @num;
}

#user {
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  background-color: var(--bg);

  .right_icon {
    display: flex;
    align-items: center;
    gap: 15px;
  }

  .progress_ {
    width: 60%;

    .progress_text {
      font-size: calc(14rem / 16);
      margin-left: calc(15rem / 16);
    }

    .progress {
      flex: 1;
      // padding: calc(7rem / 16) 0;
      display: flex;
      align-items: flex-end;
      font-size: calc(15rem / 16);

      // /deep/ .van-progress {
      //   flex: 1;
      //   margin-right: calc(7rem / 16);
      // }
    }
  }

  // background-color: rgb(245, 245, 245);
  .userInfo_bar_wrap {
    overflow: hidden;
    background-size: 100% 100%;
    background-color: var(--bg);
  }

  .spancolor {
    color: @Color;
  }

  // 顶部
  .user_title {
    // padding: 5.333vw 4vw;

    height: 26.667vw;
    overflow: hidden;
    color: var(--gold);
    // background: url(../../assets/Img/myImg/bg_01.6e175c41.png) no-repeat top;
    background: var(--navTheme);
  }

  .user_titleContent {
    display: flex;
    justify-content: space-between;
    margin: @wrapPadding;

    .user_contentLeft {
      flex: 1;
      display: flex;


      .contentLeft_text {
        margin-left: 10px;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        .username {
          color: var(--textColor);
          font-size: calc(16rem / 16);
          display: flex;
          align-items: center;

          .rank {
            color: var(--textColor);
            font-size: calc(16rem / 16);
            display: flex;
            align-items: center;

            img {
              width: 30px;
              display: block;
              margin-right: calc(8rem / 16);
              animation: moveUpDown 1s infinite alternate;
            }

            @keyframes moveUpDown {
              0% {
                transform: translateY(-5px);
              }

              100% {
                transform: translateY(5px);
              }
            }
          }
        }

        .userInfo {
          display: flex;
          align-items: center;
          gap: 20px;
          margin-top: 10px;
          margin-bottom: 5px;
        }

        .userInfo_id {
          color: var(--textColor);
          font-size: calc(14rem / 16);
        }

        .balance_bar {
          font-size: calc(16rem / 16);
          font-weight: 700;
          color: var(--theme);
          // background: linear-gradient(180deg, #ffe692, #ffd759 35.5%, #ffe58e 67.75%, #f79c17);
          // -webkit-background-clip: text;
          // background-clip: text;
          // -webkit-text-fill-color: transparent;
        }
      }
    }

    .user_contentRight img {
      width: 7vw;
      height: 7vw;
    }
  }

  .top_nav_bg {
    margin: @wrapPadding;
    background: var(--btn_bg);
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, .1);
    height: calc(63rem / 16);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;

    .top_nav_item {
      display: flex;
      align-items: center;
      gap: calc(10rem / 16);

      img {
        width: calc(35rem / 16);
        height: calc(35rem / 16);
        display: block;
      }

      span {
        color: var(--light);
        font-size: calc(14rem / 16);
        font-weight: 700;
      }
    }
  }

  // 中间
  .user_content {
    padding: 0 calc(12rem / 16) calc(11rem / 16);

    .btns {
      display: flex;
      padding-top: calc(4rem / 16);

      .btn_item {
        width: 25%;
        .flex(normal);
        flex-direction: column;

        .item_icon {
          width: calc(60rem / 16);
          height: calc(60rem / 16);
          border-radius: 50%;
          background: linear-gradient(180deg, #f4e0b3, #dec17e 50%, #c8a149);
          .flex();

          .icon {
            width: calc(36rem / 16);
            height: calc(36rem / 16);
            display: block;
          }
        }

        .text {
          text-align: center;
          color: var(--textColor);
          font-size: calc(14rem / 16);
          margin-top: calc(6rem / 16);
        }
      }
    }

    .balance_wrap {
      padding: 5vw;

      .balance_text {
        color: #b8ecff;
        margin-bottom: 5vw;
      }

      .contentCase_btns {
        .flex(space-around);

        .contentCase_btn {
          padding: 1.867vw 2vw;
          font-size: 3.733vw;
          line-height: normal;
          color: var(--textColor);
          text-align: center;
          border-radius: 7.467vw;
          background-color: @Color;
          // background: @comBG;
        }
      }

      .moey_num {
        color: @Color;
        font-size: 6.4vw;
        font-weight: 400;
      }
    }
  }

  .group {
    margin: 10px @wrapPadding;
    border-radius: @comRadius;
    @bg: #f5f5f5;
    overflow: hidden;
    background-color: transparent;

    &::after {
      border: none;
    }

    /deep/ .cell_item {
      background: var(--btn_bg);

      .van-cell__right-icon {
        color: transparent;
      }

      &::after {
        border-color: var(--borderColor);
      }

      .left_wrap {
        display: flex;
        align-items: center;
        color: var(--light);

        .iconfonts {
          font-size: calc(26rem / 16);
          margin-right: calc(12rem / 16);
          color: var(--light);
          width: calc(26rem / 16);
          height: calc(26rem / 16);
          display: block;
        }
      }
    }
  }

  // 第二个板块
  .caseT {
    margin-top: 5vw;
  }

  .logout {
    margin: @wrapPadding;
    margin-top: calc(35rem / 16);
    border-radius: 6px;
    overflow: hidden;
  }

  .van-grid-item__content {
    justify-content: start;
  }
}

.user_img {
  width: 15vw;
  border-radius: 10vw;
}
</style>